let CancelToken;
let source;

const Config = require('~/config/default.env').default;
import { DEFAULT_FIELDS_BRAND } from '@/constant/fields';

export default {
  namespaced: true,
  state: {
    keyword: '',
    search_result: {
      products: [],
      brands: [],
    },
    show_search: false,
    suggestions: {
      brands: [],
      products: [],
      suggestions_keyword: '',
      tags: [],
      banner: [],
      category: [],
      related: {},
      exact_brand: false,
      exact_tag: false,
      exact_product: false,
      fetched: false,
    },
    suggestionsOnFocus: {
      bestSeller: [],
      popularProducts: [],
      popularBrands: [],
      tagConcern: [],
    },
    loading: false,
    trendingSearch: [],
    exclusiveAndTrendingTabs: {},
  },
  mutations: {
    KEYWORD(state, data) {
      state.keyword = data;
    },
    SEARCH_RESULT(state, { data, name }) {
      state.search_result[name] = data;
    },
    SHOW_SEARCH(state, data) {
      state.show_search = data;
    },
    SET_SUGGESTION(state, data) {
      state.suggestions = data;
    },
    ASSIGN_SUGGESTION(state, { key, data }) {
      state.suggestions[key] = data;
    },
    SET_SUGGESTION_ON_FOCUS(state, { name, value }) {
      state.suggestionsOnFocus[name] = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_TRENDING_SEARCH(state, data) {
      state.trendingSearch = data;
    },
    SET_EXCLUSIVE_AND_TRENDING_TABS(state, data) {
      state.exclusiveAndTrendingTabs = data;
    },
  },
  actions: {
    searchSuggestion({ commit, state, dispatch }, { keyword, limit = 5 }) {
      try {
        window.dataLayer.push({
          event: 'search',
          searchKeyword: keyword,
        });
      } catch (err) {
        console.log(err);
      }
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      return axios
        .all([
          axios
            .get(`${Config.MS_CATALOG_API_URL}/v3/brand/search`, {
              params: {
                filter: {
                  keyword: keyword,
                },
                limit: 3,
                fields: DEFAULT_FIELDS_BRAND,
              },
              cancelToken: source.token,
            })
            .catch(() => {
              return false;
            }),
          axios
            .get(`${Config.MS_CATALOG_API_URL}/v3/search`, {
              params: {
                filter: {
                  keyword: keyword,
                },
                limit: 5,
                // sort: '-total_orders'
              },
              cancelToken: source.token,
            })
            .catch(() => {
              return false;
            }),
          //   axios
          //     .get(`${this._vm.$customConfig.API.tags}`, {
          //       params: {
          //         filter: {
          //           name: { $regex: keyword, $options: 'i' },
          //           is_show_in_search: true,
          //         },
          //         skip: 0,
          //         fields: '_id name icon',
          //       },
          //       cancelToken: source.token,
          //     })
          //     .catch(() => {
          //       return false;
          //     }),
        ])
        .then((response) => {
          const products = response[1];
          const brands = response[0];
          const tags = response[2];
          if (products.status === 200 || brands.status === 200 || tags.status === 200) {
            const suggestions = {};

            suggestions.brands = brands ? brands.data.data : [];
            suggestions.products = products ? products.data.data : [];
            suggestions.suggestions_keyword = keyword;
            suggestions.tags = (tags.data.data || []).map((x) => {
              const newData = Object.assign({}, x);
              newData['url_search'] = x.name.toLowerCase().replace(' ', '-');
              return newData;
            });

            commit('ASSIGN_SUGGESTION', suggestions);
          } else {
            commit('ASSIGN_SUGGESTION', {
              brands: [],
              products: [],
              suggestions_keyword: keyword,
            });
          }
          return response;
        });
    },
    //       searchByBestSeller ({commit}, payload) {
    //         return axios.get(this._vm.$customConfig.API.search, {
    // 		params: {
    // 		  skip: 0,
    // 		  limit: 5,
    // 		  sort: '-total_orders'
    // 		}
    //         })
    //         .then((response) => {
    //           if (response.status === 200) {
    //             commit('SET_SUGGESTION_ON_FOCUS', {name: 'bestSeller', value: response.data.data})
    //           }
    //           else {
    //             commit('SET_SUGGESTION_ON_FOCUS', {name: 'bestSeller', value: response.data.data})
    //           }
    //         })
    //         .catch((err) => {
    //           commit('SET_SUGGESTION_ON_FOCUS', {name: 'bestSeller', value: response.data.data})
    //         })
    //       },
    searchByPopularProducts({ commit }, payload) {
      return axios
        .get(`${Config.MS_ANALYTICS_API_URL}/product/ppr`, {
          params: {
            filter: { applicable_for: { $in: ['sociolla'] } },
            sort: '-created_at',
            fields: 'id name brand images review_stats total_reviews default_category',
            skip: 0,
            limit: 5,
          },
          headers: { source: 'sociolla' },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('SET_SUGGESTION_ON_FOCUS', {
              name: 'popularProducts',
              value: response.data.data,
            });
          } else {
            commit('SET_SUGGESTION_ON_FOCUS', {
              name: 'popularProducts',
              value: response.data.data,
            });
          }
        })
        .catch((err) => {
          commit('SET_SUGGESTION_ON_FOCUS', {
            name: 'popularProducts',
            value: response.data.data,
          });
        });
    },
    searchByPopularBrands({ commit }, payload) {
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/brands`, {
          params: {
            filter: {
              is_featured: true,
            },
            sort: '-total_reviews',
            skip: 0,
            limit: 5,
            fields: DEFAULT_FIELDS_BRAND,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('SET_SUGGESTION_ON_FOCUS', {
              name: 'popularBrands',
              value: response.data.data,
            });
          } else {
            commit('SET_SUGGESTION_ON_FOCUS', {
              name: 'popularBrands',
              value: response.data.data,
            });
          }
        })
        .catch((err) => {
          commit('SET_SUGGESTION_ON_FOCUS', {
            name: 'popularBrands',
            value: response.data.data,
          });
        });
    },
    // getTagConcern({ commit }) {
    //   return axios
    //     .get(`${this._vm.$customConfig.API.tags}`, {
    //       params: {
    //         filter: {
    //           is_show_in_search: true,
    //         },
    //         limit: 20,
    //         fields: '_id name icon',
    //       },
    //     })
    //     .then((response) => {
    //       let value = [];
    //       if (response.status === 200) {
    //         value = response.data.data.map((x) => {
    //           const newData = Object.assign({}, x);
    //           newData['url_search'] = x.name.toLowerCase().replace(' ', '-');
    //           return newData;
    //         });
    //       }
    //       commit('SET_SUGGESTION_ON_FOCUS', { name: 'tagConcern', value });
    //     })
    //     .catch(() => commit('SET_SUGGESTION_ON_FOCUS', { name: 'tagConcern', value: [] }));
    // },
    setKeyword({ commit, state, dispatch }, data) {
      commit('KEYWORD', data);
    },
    showSearch({ commit, state, dispatch }, data) {
      commit('SHOW_SEARCH', data);
    },
    clearSearch({ commit, state, dispatch }) {
      const reset = {
        products: [],
        brands: [],
      };
      commit('SHOW_SEARCH', false);
      commit('SEARCH_RESULT', reset);
      commit('KEYWORD', '');
    },
    async fetchTrendingSearch({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(`${this._vm.$customConfig.API.trendingSearch}`, {
              params: {
                limit: 5,
                skip: 0,
                sort: '-count',
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            if (response.data.data.length <= 0) {
              commit('SET_TRENDING_SEARCH', ['skintific', 'cosrx', 'avoskin', 'esqa', 'azarine']);
            } else {
              commit('SET_TRENDING_SEARCH', response.data.data);
            }
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    async fetchExclusiveAndTrendingTabs({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(this._vm.$customConfig.API.suggestions, {
              params: {
                filter: {
                  types: ['new_exclusive', 'trending'],
                },
                limit: 5,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            commit('SET_EXCLUSIVE_AND_TRENDING_TABS', response.data.data);
            return response.data.data;
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    setSuggestion({ commit }, { response, keyword }) {
      if (!response) {
        commit('SET_SUGGESTION', {
          suggestions_keyword: keyword,
          brands: [],
          products: [],
          tags: [],
          banner: [],
          category: [],
        });
      } else {
        if (response.status === 200 && response.data.data) {
          const suggestions = {};
          const data = response.data.data;

          suggestions.tags = (data.tag || []).map((x) => {
            const newData = Object.assign({}, x);
            newData['url_search'] = x.name.toLowerCase().replace(' ', '-');
            return newData;
          });
          suggestions.banner = data.banner;
          suggestions.category = data.category;
          suggestions.suggestions_keyword = keyword;
          // suggestions.brands =
          //   data.exact_brand === false
          //     ? data.brand
          //     : (data.brand || []).filter((brand) => {
          //         return String(brand.name || '')
          //           .toLowerCase()
          //           .includes(String(keyword).toLowerCase());
          //       });
          suggestions.brands = data.brand;
          suggestions.products = data['add-review'];

          suggestions.exact_brand = data.exact_brand;
          suggestions.exact_product = data.exact_product;
          suggestions.exact_tag = data.exact_tag;

          for (const key in suggestions) {
            commit('ASSIGN_SUGGESTION', {
              key: key,
              data: suggestions[key],
            });
          }
        } else {
          commit('SET_SUGGESTION', {
            suggestions_keyword: keyword,
            brands: [],
            products: [],
            tags: [],
            banner: [],
            category: [],
          });
        }
      }
    },
    async fetchSuggestionsV2({ state, dispatch, commit }, keyword) {
      if (state.suggestions.fetched) {
        return;
      }
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(this._vm.$customConfig.API.socoGlobalSearch, {
              params: {
                filter: {
                  keyword: keyword,
                  types: ['tag', 'banner', 'category', 'brand', 'add-review'],
                  is_old_request: true,
                  is_old_response: false,
                  skip_counts: true,
                  is_global_search: true,
                },
                limit: 5,
                skip: 0,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          dispatch('setSuggestion', { response, keyword });
        })
        .catch((error) => {
          throw new Error(error);
        })
        .finally(() => {
          commit('ASSIGN_SUGGESTION', {
            key: 'fetched',
            data: true,
          });
        });
    },
    async fetchEventSuggestions({ commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(this._vm.$customConfig.API.suggestions, {
              params: {
                filter: {
                  keyword: keyword,
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            const data = response.data.data;
            commit('ASSIGN_SUGGESTION', {
              key: 'related',
              data: data,
            });
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
  },
};
